var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns is-multiline" }, [
    _c(
      "div",
      { staticClass: "column is-12-mobile is-6" },
      [
        _c("AppInputField", {
          attrs: {
            id: "companyName",
            name: "name",
            label: "Razón social:",
            "left-icon": "label",
            placeholder: "Machete SA de CV",
            value: _vm.companyName,
            loading: _vm.loading,
            disabled: _vm.loading,
            required: ""
          },
          on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column is-12-mobile is-6" },
      [
        _c("AppInputRfc", {
          attrs: {
            value: _vm.rfc,
            disabled: _vm.loading,
            loading: _vm.loading,
            "valid-icon": false,
            required: ""
          },
          on: { input: _vm.onChangeRfc, change: _vm.onChangeRfc }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column is-12-mobile is-6" },
      [
        _c("AppInputEmail", {
          attrs: {
            value: _vm.email,
            disabled: _vm.loading,
            loading: _vm.loading,
            required: ""
          },
          on: { input: _vm.onChange, change: _vm.onChange }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column is-12-mobile is-6" },
      [
        _c("AppInputPhoneNumber", {
          attrs: {
            value: _vm.phoneNumber,
            disabled: _vm.loading,
            loading: _vm.loading,
            "valid-icon": false
          },
          on: { input: _vm.onChange, change: _vm.onChange }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column is-12-mobile is-6" },
      [
        _c("AppInputPassword", {
          attrs: {
            value: _vm.password,
            disabled: _vm.loading,
            loading: _vm.loading,
            required: ""
          },
          on: { input: _vm.onChange, change: _vm.onChange }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column is-12-mobile is-6" },
      [
        _c("AppInputPassword", {
          attrs: {
            id: "passwordConfirmation",
            name: "passwordConfirmation",
            label: "Repetir Contraseña",
            "error-message": "Las contraseñas no coinciden",
            value: _vm.passwordConfirmation,
            pattern: _vm.password,
            loading: _vm.loading,
            disabled: _vm.loading,
            required: ""
          },
          on: { input: _vm.onChange, change: _vm.onChange }
        })
      ],
      1
    ),
    _vm.referCode
      ? _c(
          "div",
          { staticClass: "column is-12-mobile is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "referencedCode",
                name: "referencedCode",
                label: "Código de referencia",
                "left-icon": "label",
                placeholder: "E01DXA",
                value: _vm.referencedCode,
                loading: _vm.loading,
                disabled: _vm.loading
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }